/***
 *Â @FileName: åºé¨ç»ä»¶
 *Â @Author: manyao.zhu
 *Â @Date: 2020-05-06 10:39:10
 */
import { Component, Input, OnInit } from '@angular/core';

import { SettingsService } from '@ithinkdt/shared/browser';
import { ThemeConfig } from '@ithinkdt/theme/models';

@Component({
  selector: 'dt-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  @Input() fixWidth = false; // æ¯å¦åºå®å®½åº¦

  themeConfig: ThemeConfig;

  constructor(private settings: SettingsService) {
    this.themeConfig = this.settings.userConfig['theme'] || {};
  }

  ngOnInit() {}
}
